"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DATE_TIME_FORMAT = exports.CALENDAR_VIEW_MODE = void 0;
var CALENDAR_VIEW_MODE = {
  DATE_ONLY: 'days',
  TIME_ONLY: 'time',
  DATE_TIME: 'dateTime'
};
exports.CALENDAR_VIEW_MODE = CALENDAR_VIEW_MODE;
var DATE_TIME_FORMAT = {
  longYear: 'yyyy',
  shortMonth: 'MMMM YYYY',
  dateTimeAMPM: 'MM/dd/yyyy hh:mm aa',
  shortTimeAMPM: 'hh:mm A',
  dayOfWeek: 'dddd',
  shortDate: 'MM/dd/yyyy',
  EXECUTION_DATE_TIME: 'MMM DD, YYYY [at] h:mm A'
};
exports.DATE_TIME_FORMAT = DATE_TIME_FORMAT;
var _default = {
  IgnoreCachedTimezone: true,
  TimeConstraint: {
    minutes: {
      step: 30,
      min: 0
    },
    startTime: {
      hours: 9,
      minutes: 0,
      seconds: 0
    },
    endTime: {
      hours: 17,
      minutes: 0,
      seconds: 0
    }
  }
};
exports.default = _default;